class PropiedadFamiliaProductoTraduccion
{
  idFamiliaProductoTraduccion = 0;
  nombrePropiedad=null;
  idiomas_idIdioma = 0;
  familiaProducto_idFamiliaProducto = 0;
  idioma = null;

  constructor(obj = {}) {
    Object.assign(this, obj);
  }
}

module.exports = PropiedadFamiliaProductoTraduccion;

